import { nonUndefined } from "Utility";

export type DriverTime = {
  driverId: string;
  finishTimeMs: number | undefined;
};

export const isDnf = (time: DriverTime) =>
  time.finishTimeMs !== undefined && time.finishTimeMs < 0;

export const isFinish = (time: DriverTime) =>
  time.finishTimeMs !== undefined && time.finishTimeMs > 0;

export const getSortedDriverFinishTimes = (times: DriverTime[]) => {
  const definedTimes = nonUndefined(times.map((t) => t.finishTimeMs)).filter(
    (t) => !!t
  );

  return definedTimes.sort((a, b) => {
    if (a === b) {
      return 0;
    }

    if (a === -1) {
      return 1;
    }

    if (b === -1) {
      return -1;
    }

    return a - b;
  });
};
